import { WEEK_DAYS } from '@shared/schedule/constants';

import { IRawSchedule, IWeekSchedule } from '../../models';
import { fromBackendFormatDay } from './from-backend-format-day';

export function fromBackendFormatWeek(schedule: IWeekSchedule): Array<Array<Array<IRawSchedule>>> {
  let hoursDefaultSchedule: IRawSchedule[][][] = [];
  for (const day of WEEK_DAYS) {
    hoursDefaultSchedule.push(fromBackendFormatDay(schedule.hours[day]));
  }
  return hoursDefaultSchedule;
}
